import { Group, Paper, Stack, Text } from '@mantine/core';

import { IconExternalLink } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { FeatureFlagGuard } from '../../../shared/components/FeatureFlagGuard';
import { FeatureFlag } from '../../../shared/entities/FeatureFlags';
import { PreviewSection } from './PreviewSection';
import { Section } from './Section';
import type { useSearchTendersPreviewQuery } from './forms/hooks/streams.hook';
import type { SearchTendersPreviewQueryKey } from './forms/hooks/useStreamForm';

export function PreviewSidebar({
  previewQuery,
  queryKeys,
}: {
  previewQuery: ReturnType<typeof useSearchTendersPreviewQuery>;
  queryKeys: SearchTendersPreviewQueryKey[];
}) {
  return (
    <Stack spacing="04" w="25%" sx={{ overflow: 'auto' }}>
      <GuideCard />
      <FeatureFlagGuard feature={FeatureFlag.TENDER_PREVIEW_ON_STREAM_EDITION}>
        <PreviewSection queryKeys={queryKeys} previewQuery={previewQuery} />
      </FeatureFlagGuard>
    </Stack>
  );
}

function GuideCard() {
  const { t } = useTranslation('stream');

  return (
    <Section>
      <Paper px="04" py="03">
        <Stack spacing="03">
          <Text variant="sm" fw={500} color="gray.9">
            {t('editStreamForm.guideCard.title')}
          </Text>

          <Text variant="sm" fw={400} c="gray.6">
            {t('editStreamForm.guideCard.description')}
          </Text>
          <GuideLink />
        </Stack>
      </Paper>
    </Section>
  );
}

function GuideLink() {
  const { t } = useTranslation('stream');

  return (
    <a
      href="https://www.notion.so/tengo-cc/Guide-d-utilisation-des-flux-169bb4509e3880c1bd18d1fae53ce8fb"
      target="_blank"
      rel="noreferrer"
      style={{ textDecoration: 'none' }}
    >
      <Text variant="xs" fw={500} c="primary.7">
        <Group noWrap align="center" spacing="02">
          {t('editStreamForm.guideCard.openGuide')}
          <IconExternalLink size={16} />
        </Group>
      </Text>
    </a>
  );
}
